import repository from '@/utils/repository';

export default {
    searchEmployeeInfo: (data) => {
        return repository.post(`/move/postCommonEmployeeInfo`, {
            ...data
        });
    }
};
